<template>
    <Link v-if="href" :href="href" class="inline-flex items-center justify-center px-4 py-2 bg-red-600 text-white shadow-md rounded font-semibold text-xs uppercase hover:bg-red-500 focus:outline-none focus:border-red-700 focus:ring focus:ring-red-200 active:bg-red-600 disabled:opacity-25 transition">
        <slot></slot>
    </Link>

    <button v-else :type="type" class="inline-flex items-center justify-center px-4 py-2 bg-red-600 shadow-md rounded border-0 font-semibold text-xs text-white uppercase tracking-widest hover:bg-red-500 focus:outline-none focus:border-red-700 focus:ring focus:ring-red-200 active:bg-red-600 disabled:opacity-25 disabled:cursor-not-allowed transition">
        <slot></slot>
    </button>
</template>

<script>
    import { Link } from '@inertiajs/inertia-vue3';

    export default {
        props: {
            type: {
                type: String,
                default: 'button',
            },

            href: String,
        },

        components: {
            Link,
        }
    }
</script>
